/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_Language_SelectInputs */



/**
* | output |
* | --- |
* | "Target Language Select" |
*
* @param {Target_Language_SelectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const target_language_select = /** @type {((inputs?: Target_Language_SelectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_Language_SelectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélection de la langue cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zielsprache auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona la lingua di destinazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбор целевого языка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar idioma de destino")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("目标语言选择")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ターゲット言語の選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य भाषा चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o idioma de destino")
	return /** @type {LocalizedString} */ ("Target Language Select")
});